/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Message_Received_Body_ExpandedInputs */

const en_notifications_message_received_body_expanded = /** @type {(inputs: Notifications_Message_Received_Body_ExpandedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open the conversation to read and reply.`)
};

const pt_br2_notifications_message_received_body_expanded = /** @type {(inputs: Notifications_Message_Received_Body_ExpandedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abra a conversa para ler e responder.`)
};

/**
* | output |
* | --- |
* | "Open the conversation to read and reply." |
*
* @param {Notifications_Message_Received_Body_ExpandedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const notifications_message_received_body_expanded = /** @type {((inputs?: Notifications_Message_Received_Body_ExpandedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Message_Received_Body_ExpandedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_notifications_message_received_body_expanded(inputs)
	return pt_br2_notifications_message_received_body_expanded(inputs)
});